// src/utils/date.ts
const fmtLocal = new Intl.DateTimeFormat("fr-FR", {
  day: "2-digit",
  month: "2-digit",
  year: "numeric",
});

const fmtUTC = new Intl.DateTimeFormat("fr-FR", {
  day: "2-digit",
  month: "2-digit",
  year: "numeric",
  timeZone: "UTC",
});

export function formatDDMMYYYY(
  value: string | number | Date | null | undefined,
  opts?: { utc?: boolean }
) {
  if (!value) return "";
  const d = value instanceof Date ? value : new Date(value);

  if (isNaN(d.getTime())) return "";
  return (opts?.utc ? fmtUTC : fmtLocal).format(d);
}
